import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=013c4ff0&scoped=true"
import script from "./ProvidersList.vue?vue&type=script&lang=js"
export * from "./ProvidersList.vue?vue&type=script&lang=js"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=013c4ff0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c4ff0",
  null
  
)

export default component.exports